<template>
  <div class="refresh-bar">
    Last Updated:
    <span class="refresh-bar__date">{{ lastRefreshDate | dateTimezone('MMM D, YYYY [at] h:mma', timezone) }}</span>
    <span v-if="updatable" :class="['refresh-bar__button', fetching && 'refresh-bar__button_waiting']" @click="update">
      <FontAwesomeIcon :icon="['fas', 'sync']" />
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { dateTimezone } from '@/utils/filters';

export default {
  name: 'RefreshBar',

  components: {
    FontAwesomeIcon,
  },

  props: {
    lastRefreshDate: {
      type: Number,
      default: Date.now(),
    },
    updatable: {
      type: Boolean,
      default: true,
    },
    fetching: {
      type: Boolean,
      default: false,
    },
  },

  filters: {
    dateTimezone,
  },

  computed: {
    ...mapGetters(['userProfile']),

    timezone() {
      if (!this.userProfile) {
        return null;
      }

      return this.userProfile.timezone;
    },
  },

  methods: {
    update() {
      if (this.fetching) {
        return;
      }

      this.$emit('update');
    },
  },
};
</script>

<style lang="scss" scoped>
.refresh-bar {
  font-size: 0.75rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  letter-spacing: 0.35px;

  @include respond-to(desktop) {
    flex: 0 0 auto;
    margin-left: 50px;
    justify-content: flex-end;
  }

  &__button {
    font-size: 0.8275rem;
    margin-left: 1.5rem;
    cursor: pointer;

    &:hover {
      color: $default-blue;
    }

    &_waiting {
      animation-name: spin;
      animation-duration: 2s;
      animation-fill-mode: forwards;
      animation-iteration-count: infinite;
    }
  }

  &__date {
    margin-left: 0.25rem;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
